import { delay, put, select, take, race } from 'redux-saga/effects';
import { REFRESH_TOKEN_REQUEST, STORE_TOKENS } from '../actions/authActions';

export function* watchTokenExpiration() {
    while (true) {
        const { accessToken, refreshToken } = yield select(state => state.auth);
        if (accessToken && refreshToken) {
            try {
                const jwtPayload = JSON.parse(atob(accessToken.split('.')[1]));
                const expTime = jwtPayload.exp * 1000;
                const timeLeft = expTime - Date.now();

                if (timeLeft > 0) {
                    const { tokensUpdated } = yield race({
                        timeout: delay(timeLeft),
                        tokensUpdated: take(STORE_TOKENS),
                    });
                    if (tokensUpdated) continue; 
                }

                const { accessToken: latestToken, refreshToken: currentRefreshToken } = yield select(state => state.auth);
                if (!currentRefreshToken) {
                    yield take(STORE_TOKENS);
                    continue;
                }

      
                try {
                    const latestPayload = JSON.parse(atob(latestToken.split('.')[1]));
                    const realTimeLeft = latestPayload.exp * 1000 - Date.now();
                    if (realTimeLeft > 5000) {
                        continue; 
                    }
                } catch (e) {
                   
                }

                yield put({ type: REFRESH_TOKEN_REQUEST, payload: { refreshToken: currentRefreshToken } });

                const { failed } = yield race({
                    success: take('REFRESH_TOKEN_SUCCESS'),
                    failed: take('LOGOUT_REQUEST'),
                });

                if (failed) {
                    yield take(STORE_TOKENS);
                }

            } catch (error) {
                console.error("Error decoding accessToken:", error);
                yield delay(30 * 1000);
            }
        } else {
            yield take(STORE_TOKENS);
        }
    }
}